import React, { Component } from "react";
import {
  Avatar,
  Button,
  CircularProgress,
  MenuItem,
  TextField,
  Box,
  TablePagination,
  Menu,
} from "@material-ui/core";
import { Translation } from "react-i18next";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import { FiMusic, FiPlus } from "react-icons/fi";
import Compose from "./Compose";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import clsx from "clsx";
import {
  messageTypes,
  contentRequestStatusList,
  attachmentTypes,
  playlistShareRequestAction,
} from "./Const";
import { _newMessage } from "./Utils";
import DateTimeRenderer from "../../util/cell-renderer/DateTimeRenderer";
import { Link } from "react-router-dom";
import { FaWpforms } from "react-icons/fa";
import { MdLibraryMusic, MdPlaylistPlay } from "react-icons/md";
import { defaultPopupResults, pagingTotalRelation, resultsPerPage, userOrgStatus } from "../../redux/Types";
import ContentRequest from "./ContentRequest";
import { userDisplayInbox, userDisplayImage } from "../../util/CommonFunc";
import PermittedContent from "../../_module/component/permitted-content/PermittedContent";
import { BiMessageAdd } from "react-icons/bi";
import { appConfig } from "App";
class Messages extends Component {
  totalResults = 0;
  page = 0;
  rowsPerPage = defaultPopupResults;
  constructor(props) {
    super();
    this.state = {
      messageFilter: "inbox",
      messageKeyword: "",
      anchorEl: null,
      ContentRequestDialogOpen: false,
    };
  }

  handleClose = () => {
    const { editMessage, onClose, setUsePopup, search, setQuery, messages: { query },} = this.props;
    setUsePopup(false);
    editMessage(null);
    onClose();

    let newQuery = { ...query, q: "", page: 0 };
    setQuery(newQuery);
    search(newQuery, true);
  };

  handleOpenMenu = (event) => this.setState({ anchorEl: event.currentTarget });
  handleCloseAddMenu = () => this.setState({ anchorEl: null });

  onContentRequestClick = (event) => {
    this.handleCloseAddMenu();
    this.setState({ ContentRequestDialogOpen: true });
  };

  handleCloseContDialog = () => {
    this.setState({ ContentRequestDialogOpen: false, anchorEl: null });
  };

  handleOnSubmitSearchForm = (e) => {
    e.preventDefault();
    const {
      search: messageSearch,
      messages: { query },
      setQuery,
    } = this.props;

    let newQuery = { ...query, page: 0 };
    setQuery(newQuery);
    messageSearch(newQuery);
  };

  handleOnChangeMessageKeyword = (e) => {
    const {
      setQuery,

      messages: { query },
    } = this.props;

    setQuery({ ...query, q: e.target.value });
  };

  handleOnClickReplyMessage = (event, message) => {
    const {
      editMessage,
      user, 
      user: { id:  userId, email },
      setUnreadCount,
      messages: { totalUnread },
    } = this.props;

    if(this.isExternalPlaylistShareRequest(message)){ return; }
    if (!message.seenusers.includes(email.trim())) {
      setUnreadCount(totalUnread > 0 ? totalUnread - 1 : totalUnread);
    }
    message.seenusers.push(email.trim());
    editMessage({
      id: message.id,
      parent: message.parent,
      togroups: message.togroups,
      tousers: message.tousers,
    });
  };

  handleOnChangeMessageFilter = (e) => {
    const {
      setQuery,
      search: messageSearch,
      messages: { query },
    } = this.props;

    let newQuery = { ...query, inPage: e.target.value };
    setQuery(newQuery);
    messageSearch(newQuery);
  };

  newMessage = () => {
    const { editMessage } = this.props;
    this.handleCloseAddMenu();
    editMessage(_newMessage(messageTypes.TEXT, [], "New message"));
  };

  typeToString = (type) => {
    switch (type) {
      case messageTypes.CLEARANCE_FORM:
        return "CF";
      case messageTypes.CLEARANCE_TRACK:
        return "CT";
      case messageTypes.CONTENT:
        return "C";
      case messageTypes.TEXT:
        return "T";
      default:
        return "T";
    }
  };

  getMsgTypeClass = (type) => {
    switch (type) {
      case messageTypes.CLEARANCE_FORM:
        return "Purple";
      case messageTypes.CLEARANCE_TRACK:
        return "Green";
      case messageTypes.CONTENT:
        return "Yellow";
      case messageTypes.TEXT:
        return "Blue";
      default:
        return "Blue";
    }
  };

  getTitleforType = (type) => {
    switch (type) {
      case messageTypes.CLEARANCE_FORM:
        return "Clearance Form";
      case messageTypes.CLEARANCE_TRACK:
        return "Clearance Track";
      case messageTypes.CONTENT:
        return "Content";
      case messageTypes.TEXT:
        return "Text";
      default:
        return "Text";
    }
  };

  getUserInitial = (name) =>{
    return name?.charAt(0)?.toUpperCase() ?? "?";
  };

  renderAttachment = (message) => {
    const { classes } = this.props;
    return (
      <>
        {message.attachments.map(
          (obj, i) =>
            ({
              1: (
                <div key={i}>
                  <Link tabIndex={-1} to={`/mllicensingforms/${obj.id}`}>
                    <span className={classes.messagebodyattachementIcon}>
                      <FiMusic />
                    </span>
                    <span>
                      {" "}
                      {obj.name}
                      <span className={classes.composeTracksCount}>
                        ({obj.tracksCount})
                      </span>{" "}
                    </span>{" "}
                  </Link>
                </div>
              ),
              2: (
                <div key={i}>
                  <Link
                    tabIndex={-1}
                    to={`/mllicensingforms/${obj.cfid}/${obj.id}`}
                  >
                    <span className={classes.messagebodyattachementIcon}>
                      <FaWpforms />
                    </span>
                    <span>
                      {obj.cfname + ", " + obj.title}
                      <span className={classes.composeArtist}>
                        {obj.artist}
                      </span>
                    </span>{" "}
                  </Link>
                </div>
              ),

              3: (
                <div key={i}>
                  <Link
                    tabIndex={-1}
                    to={`/search/tracks/${obj.id}`}
                    key={obj.id}
                  >
                    <span className={classes.messagebodyattachementIcon}>
                      <MdLibraryMusic />
                    </span>
                    <span>
                      {obj.title}
                      <span className={classes.composeArtist}>
                        {obj.artist}
                      </span>
                    </span>
                  </Link>
                </div>
              ),
              4: (
                <div key={i}>
                  <Link tabIndex={-1} to={`/playlist/${obj.id}`}>
                    <span className={classes.messagebodyattachementIcon}>
                      <MdPlaylistPlay />
                    </span>
                    <span>
                      {" "}
                      {obj.name}
                      <span className={classes.composeTracksCount}>
                        ({obj.tracksCount})
                      </span>{" "}
                    </span>{" "}
                  </Link>
                </div>
              ),
            }[
              message.attachments[i].type
                ? message.attachments[i].type
                : message.type
            ])
        )}
      </>
    );
  };

  handleChangePage = (event, value) => {
    const {
      messages: { query },
      setQuery,
      search,
    } = this.props;
    let newQuery = {
      ...query,
      page: value ? value : 0,
      size: this.rowsPerPage,
    };
    this.page = value;
    setQuery(newQuery);
    search(newQuery);
  };

  handleChangeRowsPerPage = (event) => {
    let rowsPerPage = !isNaN(event.target.value)
      ? +event.target.value
      : this.rowsPerPage;

    const {
      messages: { query },
      setQuery,
      search,
    } = this.props;
    let newQuery = { ...query, page: 0, size: rowsPerPage };

    this.rowsPerPage = rowsPerPage;
    setQuery(newQuery);
    search(newQuery);
    this.page = 0;
  };

  setTotalItems() {
    const {
      messages: { totalItems, totalUnread },
      user: { id:  email },
      showUnreadOnly  
    } = this.props;

    // const hasseen = (m) => {
    //   return m.seenusers && m.seenusers.includes(email.trim());
    // };

    if(showUnreadOnly){
      this.totalResults =  (totalUnread !== undefined) ? totalUnread : 0;
    }
    else{
      this.totalResults =
      totalItems !== undefined
        ? totalItems !== this.totalResults
          ? totalItems
          : this.totalResults
        : this.totalResults;
    }
   
  }

  getcStatusText(status) {
    let index = contentRequestStatusList.findIndex((item) => item.id === status);
    if (index !== -1) {
      return contentRequestStatusList[index].label;
    } else {
      return "N/A";
    }
  }

  getcStatusColor = (status) =>{
    let index = contentRequestStatusList.findIndex((item) => item.id === status);
    if (index !== -1) {
      return contentRequestStatusList[index].color;
    } else {
      return null;
    }
  }

  getAttachmentText = (attachments) =>{
    let attText = attachments.map((att)=>{
      switch (att.type) {
        case attachmentTypes.TRACK:         
          return "Track";
        case attachmentTypes.CLEARANCE_FORM:         
          return "Clearance Form";

        case attachmentTypes.CLEARANCE_TRACK:         
          return "Clearance Track";
        case attachmentTypes.CLEARANCE_FORM_TRACK:         
          return "Clearance Track";

        case attachmentTypes.PLAYLIST:         
          return "Playlist";

        case attachmentTypes.ALBUM:         
          return "Album";
      
        case attachmentTypes.CONTENT_REQUEST: 
        default:
          return "";
      }
    }) || [];

    let attachmentText = `${[...new Set(attText)].join('/ ')}`

    return attachmentText.trim() !== "" ? attachmentText + " - " : "";
  }

  handlePlaylistShareRequest = (responce, message) =>{
    const {
      sharedPlaylistRequest, 
      user: { id:  email },
    } = this.props;

    let plReq = {
      sharedOrgId : message.attachments[0]?.sharedDetails?.sharedOrgId,
      messageId : message.id,
      email: email
    }

    sharedPlaylistRequest(responce, plReq, `${responce === playlistShareRequestAction.ACCEPT ? "Accepting" : "Rejecting"} request...`,this.PlSearchMessages )
  }

  PlSearchMessages = (data ,error)=>{
    const {
      messages:{query},
      search
    } = this.props;
    if(data){
      search(query,true);
    }
  }

  isExternalPlaylistShareRequest = (message)=>{
    const {messages:{ permittedOrgs } } = this.props;

    return ((message.type === messageTypes.PLAYLIST || message.type === messageTypes.INVITATION) 
      && message?.attachments?.length > 0 
      && permittedOrgs 
      && permittedOrgs[message.attachments[0]?.sharedDetails?.sharedOrgId]
      // && !permittedOrgs[message.attachments[0]?.sharedDetails?.sharedOrgId].permitted
      && permittedOrgs[message.attachments[0]?.sharedDetails?.sharedOrgId].userStatus !== userOrgStatus.ACTIVE
      ) || false
  }

  getPlayListLink =(message) =>{
    const {
      user: { orgId, email },
    } = this.props;

    let link = ""

    if(message.attachments[0]?.sharedDetails?.sharedOrgId && message.attachments[0]?.sharedDetails?.sharedOrgId !== orgId){
      link= "https://" + message.attachments[0]?.sharedDetails?.sharedOrgId + "." +
                               appConfig.MB_DOMAIN +
                                  "/tourl?url=/playlist/"+ message.attachments[0]?.id +"&origin=" +
                                  orgId + "." + appConfig.MB_DOMAIN + 
                                  "&org=" +
                                  encodeURIComponent(btoa(message.attachments[0]?.sharedDetails?.sharedOrgId)) +
                                  "&user=" +
                                  encodeURIComponent(btoa(email))
    }else{

      link = `/playlist/${message.attachments[0]?.id}`;
    }

    return link;
  }

  render() {
    const {
      classes,
      messages: { 
        editing, 
        loading, 
        loadingMore, 
        query, 
        items,
        totalRelation, 
        plReqPosting :{ busy : plShareBusy,org : plShareOrg, action : plShareAction},
        permittedOrgs 
      },
      user: { id: userid, orgId, email },
      showUnreadOnly,      
      orgRuntime: {
        runtime: {
          _Messages, _canCreateContentRequest
      
        }
      } 
    } = this.props;

    const hasseen = (m) => {
      return m.seenusers && m.seenusers.includes(email.trim());
    };

    const { anchorEl, ContentRequestDialogOpen } = this.state;

    this.setTotalItems();
    this.page = query.page;

    let msgItems = showUnreadOnly ? items.filter((m) => !hasseen(m)) : items || [];

    return (
      <Translation>
        {(t, { i18n }) => (
          <>
            {ContentRequestDialogOpen?
            <ContentRequest
              DialogOpen={ContentRequestDialogOpen}
              classes={classes}
              DialogClose={this.handleCloseContDialog}
              {...this.props}
            /> : null}
            <div className={classes.mainWrap}>
              <div className={classes.messagesTabContent}>
                {!editing && (
                  <>
                    <form
                      noValidate
                      className={classes.searchForm}
                      onSubmit={this.handleOnSubmitSearchForm}
                    >
                      <div className={classes.panelHeader}>
                        <div className={classes.panelHeaderMultiText}>
                          <h2>
                            {" "}
                            <EmailOutlinedIcon /> Inbox
                          </h2>
                        </div>
                        <Button
                          className={clsx(
                            classes.commonTopButton,
                            classes.buttonGreenButton
                          )}
                          // onClick={this.newMessage}
                          onClick={this.handleOpenMenu}
                          aria-label={"Create Message Menu"}
                        >
                          <FiPlus />
                        </Button>

                        <Menu
                          keepMounted
                          getContentAnchorEl={null}
                          anchorOrigin={{
                            horizontal: "left",
                            vertical: "bottom",
                          }}
                          id="createMessageMenu"
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={this.handleCloseAddMenu}
                          className={classes.tableFilterList}
                        >
                          <MenuItem
                            key={"newMessage"}
                            title={"Create Message"}
                            onClick={this.newMessage}
                          >
                         <BiMessageAdd className={classes.actionMenuIcon} />   Create Message
                          </MenuItem>
               

                          {/* <PermittedContent
                          modulePath={[_Messages, _canCreateContentRequest]}
                          >
                          <MenuItem
                            key={"newContentReq"}
                            title={"Create Content Request"}
                            onClick={this.onContentRequestClick}
                          >
                            <EmailOutlinedIcon className={classes.actionMenuIcon} /> Content Request
                          </MenuItem>
                          </PermittedContent> */}
                        </Menu>

                        <Button
                          className={clsx(
                            classes.commonTopButton,
                            classes.buttonCustomSize,
                            classes.globalGrayButton
                          )}
                          onClick={this.handleClose}
                          aria-label={t("messagesManager.close")}
                        >
                          <CloseIcon />
                        </Button>
                      </div>

                      <div className={classes.MessageKeywordWrapper}>
                        <label
                          className={classes.appbarHideLabel}
                          aria-hidden="true"
                          htmlFor="MessageKeyword"
                        >
                          {t("messagesManager.messageKeywordAriaLabelAll")}
                        </label>
                        <TextField
                          id="MessageKeyword"
                          name="MessageKeyword"
                          type="text"
                          autoComplete="off"
                          aria-label={t(
                            "messagesManager.messageKeywordAriaLabelAll"
                          )}
                          className={classes.searchTextField}
                          value={query.q}
                          onChange={this.handleOnChangeMessageKeyword}
                          disabled={loading || editing}
                        ></TextField>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          aria-label={t(
                            "messagesManager.messageKeywordButtonAriaLabel"
                          )}
                          className={classes.button}
                          disabled={loading || editing}
                        >
                          {loading ? (
                            <CircularProgress
                              className={classes.circularProgressIcon}
                            />
                          ) : (
                            <SearchIcon className={classes.searchIcon} />
                          )}
                        </Button>
                      </div>
                    </form>
                    

                    <div className={classes.messagesWraps} disabled={loading}>
                      {loading ? (
                        <CircularProgress
                          className={classes.circularProgressIconAsFeedback}
                        />
                      ) : items.length === 0 || (showUnreadOnly && items.filter((m) => !hasseen(m)).length === 0) ? (
                        <div className={classes.noMessage}>
                          No messages found
                        </div>
                      ) : (
                        msgItems.map((message) => {
                          return (
                            <>
                              <MenuItem
                                key={message.id}
                                className={clsx(
                                  hasseen(message)
                                    ? classes.messageBox
                                    : classes.unreadMessage,

                                   message.updatedBy  === email
                                      ? classes.sentItem
                                      : classes.receivedItem
                                )}
                                tabIndex={0}
                                onKeyDown={(event) =>
                                  event.key === "Enter"
                                    ? this.handleOnClickReplyMessage(
                                        event,
                                        message
                                      )
                                    : null
                                }
                                aria-label={t("messagesManager.message")}
                              >
                                <div
                                  className={classes.messageMainBoxContainer}
                                  onClick={(event) =>
                                    this.handleOnClickReplyMessage(event, message)
                                  }
                                >
                                  <div className={clsx( classes.messageSenderContainer, )} >
                                    <div className={clsx(classes.usersContainer, "reverseOrder")}>
                                      <Avatar alt={userDisplayInbox(message.updatedBy)} src={userDisplayImage(message.updatedBy)} className={clsx(classes.smallUserAvatar, this.getMsgTypeClass(message.type))} title={userDisplayInbox(message.updatedBy)}> {this.getUserInitial(userDisplayInbox(message.updatedBy))}  </Avatar>
                                      <div className={clsx(classes.bodyUserDetails, "userNames")} title={userDisplayInbox(message.updatedBy)}>
                                        {userDisplayInbox(message.updatedBy)}
                                      </div>
                                    </div>
                                   
                                  </div>
                                  <div className={classes.messageContentWrap}>
                                    <div className={classes.messagebodyInnerContainerNew}>
                                        {/* <div title={ message.bodyreply || message.body }>
                                          {message.bodyreply || message.body}
                                        </div> */}

                                        {(message.type === messageTypes.PLAYLIST 
                                        && message?.attachments?.length > 0 
                                        && message.attachments[0]?.sharedDetails
                                        && message.attachments[0]?.sharedDetails?.sharedOrgId !== orgId
                                        && permittedOrgs 
                                        && permittedOrgs[message.attachments[0]?.sharedDetails?.sharedOrgId]
                                        // && permittedOrgs[message.attachments[0]?.sharedDetails?.sharedOrgId].permitted)
                                        && permittedOrgs[message.attachments[0]?.sharedDetails?.sharedOrgId].userStatus === userOrgStatus.ACTIVE)
                                        ?
                                        <a  
                                          href={this.getPlayListLink(message)} 
                                          onClick={(event) =>
                                            event.stopPropagation()
                                          }
                                        > 
                                        {/* {message.bodyreply || message.body}  */}
                                        {message.subject} 
                                        </a>

                                        :

                                        message.type === messageTypes.PLAYLIST 
                                        && message?.attachments?.length > 0 
                                        && (message.createdBy === userid || message.attachments[0]?.sharedDetails?.sharedOrgId === orgId)
                                        
                                        ?

                                        <Link 
                                          tabIndex={-1} 
                                          to={`/playlist/${message.attachments[0]?.id}`}
                                          // to={this.getPlayListLink(message)}
                                          onClick={(event) =>
                                            event.stopPropagation()
                                          }
                                        >
                                          {/* {message.bodyreply || message.body}                                          */}
                                          {message.subject}                                         
                                        </Link>
                                        :
                                        
                                        <div title={ message.bodyreply || message.body }>
                                          {message.bodyreply || message.body}
                                        </div>
                                        }
                                      </div>
                                  </div>
                                  <div className={clsx(classes.messagebodyMainDate, 'smallDevices')}>
                                    {message.type ===
                                      messageTypes.CONTENT_REQUEST && (
                                      <div
                                        title={this.getcStatusText(message.cStatus)}
                                        style={{backgroundColor : this.getcStatusColor(message.cStatus)}}
                                        className={clsx(
                                          classes.messagebodyNewDate, 'smallDevices',
                                          classes.contentRequestStatus,
                                        )}
                                      >
                                        {this.getcStatusText(message.cStatus)}
                                      </div>
                                    )}

                                  {message.type !== messageTypes.CONTENT_REQUEST && message.attachments && message.attachments.length !== 0 && (
                                    <div title={this.getAttachmentText(message.attachments)} className={classes.messagebodyattachementNew} >
                                      {this.getAttachmentText(message.attachments)}
                                    </div>
                                  )}
                                    
                                    <span>
                                      <DateTimeRenderer key={message.id} data={message.updatedAt} />
                                    </span>
                                  </div>
                                  { message?.attachments?.length > 0 && (
                                    message.attachments.map(att =>{
                                      if(att.type === attachmentTypes.INVITATION ){
                                        if(message.tousers.indexOf(email) !== -1){
                                          return (<span
                                            dangerouslySetInnerHTML={{
                                              __html:att.html
                                            }}
                                          ></span>)
                                        }
                                      }
                                      else{
                                        return (<span
                                          dangerouslySetInnerHTML={{
                                            __html:att.html
                                          }}
                                        ></span>)
                                      }
                                    })
                                  ) }
                                  { (message.type === messageTypes.PLAYLIST || message.type === messageTypes.INVITATION) 
                                    && message?.attachments?.length > 0 
                                    && message.attachments[0]?.sharedDetails?.sharedOrgId
                                    && message.attachments[0]?.sharedDetails?.sharedOrgId !== orgId
                                    && 
                                    <>
                                      <hr/>
                                      {(permittedOrgs 
                                        && permittedOrgs[message.attachments[0]?.sharedDetails?.sharedOrgId]
                                        && permittedOrgs[message.attachments[0]?.sharedDetails?.sharedOrgId].busy
                                        ) 
                                        ?
                                        <>
                                          <CircularProgress
                                            className={classes.circularProgress}
                                            size={15}
                                          />
                                          loading permission...
                                        </>                                       
                                        :
                                        (permittedOrgs 
                                          && permittedOrgs[message.attachments[0]?.sharedDetails?.sharedOrgId]
                                          && permittedOrgs[message.attachments[0]?.sharedDetails?.sharedOrgId].errors
                                          )
                                        ?
                                        <div>
                                          {permittedOrgs[message.attachments[0]?.sharedDetails?.sharedOrgId].errors}
                                        </div>
                                        :
                                        <>
                                          {(this.isExternalPlaylistShareRequest(message) && message.type === messageTypes.PLAYLIST) && 
                                            <div>
                                              {`${message.attachments[0]?.sharedDetails?.sharedOrgName} is trying to sharing a playlist with you.`}
                                              {/* {`${message.attachments[0]?.sharedDetails?.sharedOrgName} is trying to sharing a playlist with you, If you accept, that you are allowed to share this playlist with others.`} */}
                                            </div>
                                          }
                                          <div className={classes.orgDetailsContainer}>
                                            <img
                                              src={message.attachments[0]?.sharedDetails?.sharedOrgImageUrl || ""}
                                              role="presentation"
                                              className={classes.organisationLogo}
                                              alt={`${message.attachments[0]?.sharedDetails?.sharedOrgName || "Org"} Logo`}
                                              
                                            />
                                            { this.isExternalPlaylistShareRequest(message) &&  
                                            <>
                                              {
                                                permittedOrgs[message.attachments[0]?.sharedDetails?.sharedOrgId].userStatus === userOrgStatus.ARCHIVED ?                                         
                                                <div>
                                                  {`Invited user is Archived in ${message.attachments[0]?.sharedDetails?.sharedOrgName}.`}
                                                </div>                                             
                                                :
                                                <>
                                                  <Button
                                                    className={clsx(classes.orgCommonButtons,classes.orgAccept)}
                                                    onClick={()=>{this.handlePlaylistShareRequest(playlistShareRequestAction.ACCEPT, message)}}
                                                    aria-label={"Accept playlist share request"}
                                                    disabled={plShareBusy || false}
                                                  >
                                                    { plShareBusy 
                                                      && plShareOrg === message.attachments[0]?.sharedDetails?.sharedOrgId 
                                                      && plShareAction === playlistShareRequestAction.ACCEPT
                                                      &&
                                                      <CircularProgress
                                                      className={classes.circularProgress}
                                                      size={15}
                                                    />
                                                    }
                                                    Accept
                                                  </Button>
                                                  <Button
                                                    className={clsx(classes.orgCommonButtons,classes.orgReject)}
                                                    onClick={()=>{this.handlePlaylistShareRequest(playlistShareRequestAction.REJECT, message)}}
                                                    aria-label={"Reject playlist share request"}
                                                    disabled={plShareBusy || false}
                                                  >
                                                    { plShareBusy 
                                                      && plShareOrg === message.attachments[0]?.sharedDetails?.sharedOrgId 
                                                      && plShareAction === playlistShareRequestAction.REJECT
                                                      &&
                                                      <CircularProgress
                                                      className={classes.circularProgress}
                                                      size={15}
                                                    />
                                                    }
                                                    Reject
                                                  </Button>
                                                </>
                                              }
                                            </>                                             
                                            }
                                            
                                          </div>                                         
                                        </>
                                      }

                                    </>
                                  }
                                
                                </div>

                              </MenuItem>

                            </>
                         );
                        })
                      )}
                      {loadingMore && (
                        <div className={classes.loadingMore}>
                          <Box m={1}>
                            <CircularProgress
                              className={classes.circularProgress}
                              size={15}
                            />{" "}
                            <span
                              style={{ fontSize: "12px", marginLeft: "5px" }}
                            >
                              Loading more
                            </span>
                          </Box>
                        </div>
                      )}
                    </div>
                   {/* pagination */}
                    <div className={classes.messagePagination}>
                      <TablePagination
                        labelRowsPerPage={""}
                        rowsPerPageOptions={resultsPerPage}
                        component={"div"}
                        count={this.totalResults} //total records count
                        rowsPerPage={this.rowsPerPage}
                        page={this.page}
                        SelectProps={{
                          inputProps: {
                            "aria-label": "results per page",
                            id: "messagePaging",
                            "aria-labelledby": "messagePaging",
                          },
                        }}
                        labelDisplayedRows={({ from, to, count }) => {
                          return(`${from.toLocaleString()}-${to.toLocaleString()} of ${(count > 0 && totalRelation === pagingTotalRelation.GREATER_THAN) ? `${count.toLocaleString()}+` : count.toLocaleString()}`)}}              
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                      />
                    </div>
                  </>
                )}

                {editing && (
                  <Compose totalResults={this.totalResults} {...this.props} />
                )}
              </div>
            </div>
          </>
        )}
      </Translation>
    );
  }
}

export default Messages;
